<template>
  <el-popconfirm
    :confirm-button-text="ConfirmButtonText"
    :cancel-button-text="CancelButtonText"
    icon="el-icon-info"
    icon-color="red"
    :title="title"
    @confirm="buttonConfirmFn"
    @cancel="buttonCancelFn"
  >
    <template slot="reference">
      <slot></slot>
    </template>
  </el-popconfirm>
</template>

<script>
/**
 * 气泡确认框组件
 */
export default {
  name: "PopConfirm",
  props: {
    // 确认按钮文字
    ConfirmButtonText: {
      type: String,
      default: "确认"
    },
    // 取消按钮文字
    CancelButtonText: {
      type: String,
      default: "取消"
    },
    // 标题
    title: {
      type: String,
      default: "是否确认删除该记录？"
    },
    // 确认事件
    buttonConfirmFn: {
      type: Function,
      default: () => {}
    },
    // 取消事件
    buttonCancelFn: {
      type: Function,
      default: () => {}
    }
  },
};
</script>

<style lang="less" scoped>
</style>
